/* assets/product-details-drawer.js */
(() => {
  const DURATION = 650;                                // adjust speed (ms)
  const EASE     = 'cubic-bezier(0.16,0.84,0.44,1)';   // adjust easing
  const supportsWAAPI = 'animate' in Element.prototype;
  const prefersReduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const lockScroll = (on) => {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };

  async function openDrawer(drawer) {
    const overlay = drawer.querySelector('.pdp-drawer__overlay');
    const panel   = drawer.querySelector('.pdp-drawer__panel');

    // 1) Make it visible per your CSS
    drawer.classList.add('is-open');
    lockScroll(true);

    // 2) Set start states to override .is-open CSS (overlay would otherwise jump to 1)
    overlay.style.opacity = '0';
    panel.style.transform = 'translateX(100%)';

    if (!supportsWAAPI || prefersReduce) {
      // No animation support — snap to end
      overlay.style.opacity = '1';
      panel.style.transform = 'translateX(0)';
      return;
    }

    // 3) Animate
    overlay.animate([{opacity:0},{opacity:1}], {
      duration: Math.max(250, DURATION - 150),
      easing: 'linear',
      fill: 'forwards'
    });

    await panel.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}], {
      duration: DURATION,
      easing: EASE,
      fill: 'forwards'
    }).finished;
  }

  async function closeDrawer(drawer) {
    const overlay = drawer.querySelector('.pdp-drawer__overlay');
    const panel   = drawer.querySelector('.pdp-drawer__panel');

    if (!supportsWAAPI || prefersReduce) {
      drawer.classList.remove('is-open');
      overlay.style.opacity = '';
      panel.style.transform = '';
      lockScroll(false);
      return;
    }

    overlay.animate([{opacity:1},{opacity:0}], {
      duration: Math.max(200, DURATION - 200),
      easing: 'linear',
      fill: 'forwards'
    });

    await panel.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}], {
      duration: DURATION,
      easing: EASE,
      fill: 'forwards'
    }).finished;

    // Cleanup and actually hide
    drawer.classList.remove('is-open');
    overlay.style.opacity = '';
    panel.style.transform = '';
    lockScroll(false);
  }

  // Click handlers (use your existing data attributes)
  document.addEventListener('click', (e) => {
    const openBtn  = e.target.closest('[data-drawer-open]');
    const closeBtn = e.target.closest('[data-drawer-close]');
    const isOverlay = e.target.classList?.contains('pdp-drawer__overlay');

    if (openBtn) {
      const drawer = document.getElementById(openBtn.getAttribute('data-drawer-open'));
      if (drawer && !drawer.classList.contains('is-animating')) {
        openDrawer(drawer);
      }
    }
    if (closeBtn || isOverlay) {
      const drawer = e.target.closest('.pdp-drawer');
      if (drawer) closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const open = document.querySelector('.pdp-drawer.is-open');
      if (open) closeDrawer(open);
    }
  });
})();

// WALLPAPER CALCULATOR
(function () {
  if (window.__wallpaperCalculatorBound) return;
  window.__wallpaperCalculatorBound = true;

  const panelWidthLabel = '25"';
  const panelHeightsInches = [48, 60, 72, 96, 108, 120].sort((a, b) => a - b);
  const maxPanelHeight = Math.max.apply(null, panelHeightsInches);

  const trimAllowanceInches = 0;
  const effectiveCoveragePerPanel = 25;

  function normalizeFeetInches(feetRaw, inchesRaw) {
    const feet = parseFloat(feetRaw) || 0;
    const inches = parseFloat(inchesRaw) || 0;

    const normalizedFeet = feet + Math.floor(inches / 12);
    const normalizedInches = inches % 12;

    return {
      totalInches: normalizedFeet * 12 + normalizedInches
    };
  }

  function choosePanelHeight(requiredHeightInches) {
    for (const h of panelHeightsInches) {
      if (h >= requiredHeightInches) return h;
    }

    return maxPanelHeight;
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('.wallpaper-calculator__form');
    if (!form) return;

    e.preventDefault();

    const resultEl = form.querySelector('.wallpaper-calculator__result');
    if (!resultEl) return;

    const wallWidth = normalizeFeetInches(
      form.elements['width_feet'] ? form.elements['width_feet'].value : 0,
      form.elements['width_inches'] ? form.elements['width_inches'].value : 0
    ).totalInches;

    const wallHeight = normalizeFeetInches(
      form.elements['height_feet'] ? form.elements['height_feet'].value : 0,
      form.elements['height_inches'] ? form.elements['height_inches'].value : 0
    ).totalInches;

    if (wallWidth <= 0 || wallHeight <= 0) {
      resultEl.textContent = 'Please enter your wall size using feet, inches, or both.';
      return;
    }

    const requiredHeight = wallHeight + trimAllowanceInches;

    if (requiredHeight > maxPanelHeight) {
      resultEl.textContent =
        'Your wall will need a custom panel height, please reach out to us for a quote.';
      return;
    }

    const panelsAcross = Math.ceil(wallWidth / effectiveCoveragePerPanel);
    const chosenHeight = choosePanelHeight(requiredHeight);
    const totalPanels = panelsAcross;

    const sizeLabel = `${panelWidthLabel} wide × ${chosenHeight}" high`;

    resultEl.textContent =
      `You’ll need ${totalPanels} panel${totalPanels === 1 ? '' : 's'} of ${sizeLabel}.`;
  });

  document.addEventListener('click', function (e) {
    const resetBtn = e.target.closest('.wallpaper-calculator__reset');
    if (!resetBtn) return;

    const form = resetBtn.closest('.wallpaper-calculator__form');
    if (!form) return;

    const resultEl = form.querySelector('.wallpaper-calculator__result');

    form.reset();

    if (resultEl) {
      resultEl.textContent = '';
    }
  });
})();